import { SVGProps } from "react"

export const Minus = (props: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="minus">
            <path id="Icon" d="M20 12L4 12" stroke="currentColor" strokeLinecap="round" />
        </g>
    </svg>
)
